import { useCallback, useEffect, useState } from 'react';
import { selfServiceApi } from '../services/selfServiceApi';
import type { DayWithLocations } from '../types';

interface TimeSlotsResult {
  days: DayWithLocations[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useTimeSlots = (daysToFetch = 14): TimeSlotsResult => {
  const [days, setDays] = useState<DayWithLocations[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchSlots = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await selfServiceApi.fetchTimeSlots(daysToFetch);
      setDays(response.days);
    } catch (err) {
      console.error('Failed to load time slots', err);
      setError('Vi kunne ikke hente ledige tider. Tjek din forbindelse og prøv igen.');
      setDays([]);
    } finally {
      setIsLoading(false);
    }
  }, [daysToFetch]);

  useEffect(() => {
    void fetchSlots();
  }, [fetchSlots, refreshToken]);

  const refetch = useCallback(() => {
    setRefreshToken(token => token + 1);
  }, []);

  return { days, isLoading, error, refetch };
};
